import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FooterBox } from './style';
import { globalStateSelector } from '../../../store/selector';
import { globalAction } from '../../../store/action';
import { connect } from 'react-redux';
import { CallFooterTheme } from 'modules/theme';

export class Footer extends Component {
  renderFooter(bgColor, text) {
    return (
		<div
			style={{ padding: "5px", background: bgColor }}
			className="col-md-12 col-sm-12 text-center"
		>
			{text}
		</div>
	);
  }
  render() {
    const { microPhone, isConnected, cbInfo, teamList, team, userState, cbNotify } = this.props;
    console.log("this is team list i want to know -> ",teamList);
    if (!isConnected) {
      return this.renderFooter(
        "#81818180",
        "Offline",
      )
    } else if (userState.State == 'online') {
      let teamId = team && team._id ? team._id : '';
      if (!teamList || teamList.length == 0) {
        return this.renderFooter(
          "#81818180",
          "You're not part of any teams",
        )
      } else if (!teamId) {
        return this.renderFooter(
          "#81818180",
          "Please select team from profile",
        )
      } else {
        return (<React.Fragment />)
      }
    } else if (cbNotify && userState.State != 'callback') {
      if (cbNotify && userState.State != 'callback') {
        if (cbInfo && cbInfo.detail) {
          let dbInfo = cbInfo.detail || {};
          let notification = dbInfo.subjectCallDetail || "Your Callback Has been schedule now";
          return this.renderFooter(
            "rgb(0 93 232 / 15%)",
            notification,
          )
        } else {
          return (<React.Fragment />);
        }
      } else {
        return (<React.Fragment />);
      }
    }
    else {
      return (
        // <CallFooterTheme />
        <React.Fragment />
      );
    }
  }
}
Footer.contextTypes = {
  __: PropTypes.func
};

const stateToProps = state => ({
  selectedTab: globalStateSelector.getSelectedTab(state),
  microPhone: globalStateSelector.getDynamic(state, { key: 'microPhone' }),
  cbInfo: globalStateSelector.getDynamic(state, { key: 'cbInfo' }),
  cbNotify: globalStateSelector.getDynamic(state, { key: 'cbNotify' }),
  teamList: globalStateSelector.getTeamList(state),
  team: globalStateSelector.getSelectedTeam(state),
  userState: globalStateSelector.getState(state),
  isConnected: globalStateSelector.getIsConnected(state),
});

const dispatchToProps = dispatch => ({
  changeTab: tName => {
    dispatch(globalAction.tabState({ data: tName }));
  }
});

export default connect(stateToProps, dispatchToProps)(Footer);



// WEBPACK FOOTER //
// src/dialpad/components/layout/Footer.js